export const COMMUNITY_PRODUCT_CATEGORY_ID = 14

export const EBOOK_CATEGORY_ID = 1

export const ONLINE_COURSE_ID = 8

export const AGENT_CATEGORY_ID = 17
